/// <amd-module name="Wit/Common/WorkItemDialogs/Components/BatchExecutionHelper" />
import { PageSizes } from "Wit/WorkItemModel/OM/";
import { ObservableValue } from "VSS/Core/Observable";

export async function executeCallbackForTargetIdsInBatches(
    targetIds: number[],
    callback: (subsetTargetIds: number[]) => Promise<boolean>,
    promissesCount?: ObservableValue<number>,
    processedCount?: ObservableValue<number>,
    maximumAmountOfSimultaneousRequests?: number,
    itemsPerStep?: number,
    allowTempIds?: boolean
): Promise<boolean> {
    const arrayOfPromises = [];
    const itemsStepToUse = itemsPerStep ?? PageSizes.QUERY;
    for (let i = 0; i < targetIds.length; i += itemsStepToUse) {
        const subsetTargetIds = targetIds.slice(i, i + itemsStepToUse).filter(id => allowTempIds || id > 0);

        arrayOfPromises.push(() => {
            return callback(subsetTargetIds);
        });
    }

    promissesCount && (promissesCount.value = arrayOfPromises.length);
    processedCount && (processedCount.value = 0);

    const _maximumAmountOfSimultaneousRequests = maximumAmountOfSimultaneousRequests ?? 5;
    let currentPromisesCount = 0;
    let currentQueryPromises = [];
    let succeeded: boolean = true;
    for (const promiseFunction of arrayOfPromises) {
        currentQueryPromises.push(promiseFunction());
        currentPromisesCount++;

        if (currentPromisesCount >= _maximumAmountOfSimultaneousRequests) {
            const results = await Promise.all(currentQueryPromises);

            if (results.some(result => !result)) {
                succeeded = false;
                return false;
            }

            processedCount && (processedCount.value = processedCount.value + _maximumAmountOfSimultaneousRequests);

            currentPromisesCount = 0;
            currentQueryPromises = [];
        }
    }

    if (currentQueryPromises.length > 0) {
        const lastBatch = await Promise.all(currentQueryPromises);

        if (lastBatch.some(result => !result)) {
            return false;
        }
    }

    succeeded && processedCount && (processedCount.value = processedCount.value + _maximumAmountOfSimultaneousRequests);

    return succeeded;
}
